import { REVERSE } from "data/reverseScores"

export function RunRules(props) {
    const {
        questions,
        get_brief_response
    } = props

    const MinQuestions = []
    const MaxQuestions = []

    const MinQuestionSet = []
    const MaxQuestionSet = []

    let maxRows = 0
    let minRows = 0

    console.log("Feedback Rules")

    if (get_brief_response?.response?.organization_styles?.rules) {

        

        const getMax = get_brief_response?.response?.organization_styles?.rules?.filter(ru => ru?.type === "max")?.[0]?.rows > 0
        maxRows = get_brief_response?.response?.organization_styles?.rules?.filter(ru => ru?.type === "max")?.[0]?.rows
        const getMin = get_brief_response?.response?.organization_styles?.rules?.filter(ru => ru?.type === "min")?.[0]?.rows > 0
        minRows = get_brief_response?.response?.organization_styles?.rules?.filter(ru => ru?.type === "min")?.[0]?.rows


        if (get_brief_response?.answers?.questions) {
            // const MaxScore = 10
            //  reverse_score = MaxScore + 1 - your_score
            const _revisedValues = Object.values(get_brief_response?.answers?.questions).map(val => {
                // console.log("Check for reverse ", val)
                if (val?.reverse === true) {
                    // console.log("reversed for ############", val)
                    return (
                        {
                            ...val,
                            response: REVERSE[val.response]
                        }
                    )
                }
                return { ...val }
            })

            if (getMax) {
                const maxValues = _revisedValues.sort((a, b) => b.response - a.response);

                maxValues.map(m => {
                    const _ques = questions[m.ques_order - 1]
                    // filter based on factor and dimensions
                    const _found = MaxQuestionSet.filter(mm => mm?.dimension === _ques?.dimension && mm?.factor === _ques?.factor)?.[0]

                    if (!_found) {
                        MaxQuestionSet.push({
                            dimension: _ques?.dimension,
                            factor: _ques?.factor
                        })

                        MaxQuestions.push({
                            ...m,
                            fr: _ques?.fr,
                            question: _ques?.question,
                            feedback: "",
                            dimension: _ques?.dimension,
                            factor: _ques?.factor,
                            type: 'max'
                        })
                    }

                    return null
                })

                // maxValues.slice(0, maxRows).map(m => {
                //     const _ques = questions[m.ques_order - 1]
                //     MaxQuestions.push({
                //         ...m,
                //         fr: _ques?.fr,
                //         question: _ques?.question,
                //         feedback: "",
                //         dimension: _ques?.dimension,
                //         factor: _ques?.factor,
                //         type: 'max'
                //     })
                //     return null
                // })
            }

            if (getMin) {
                const minValues = _revisedValues.sort((a, b) => a.response - b.response);
                // console.log(minValues.sort((a,b) => a.response - b.response).slice(0,maxRows));

                // console.log(minValues)

                minValues.map(m => {
                    const _ques = questions[m.ques_order - 1]

                    // filter based on factor and dimensions
                    const _found = MinQuestionSet.filter(mm => mm?.dimension === _ques?.dimension && mm?.factor === _ques?.factor)?.[0]

                    if (!_found) {

                        MinQuestionSet.push({
                            dimension: _ques?.dimension,
                            factor: _ques?.factor
                        })

                        MinQuestions.push({
                            ...m,
                            fr: _ques?.fr,
                            question: _ques?.question,
                            feedback: "",
                            dimension: _ques?.dimension,
                            factor: _ques?.factor,
                            type: 'min'
                        })
                    }

                    return null
                })

            }
        }
    }

    return (
        [
            ...MinQuestions.slice(0, minRows),
            ...MaxQuestions.slice(0, maxRows)
        ]
    )
}


export function AuditRunRules(questions, min_followup, max_followup, questionAnswers) {
    const MinQuestions = []
    const MaxQuestions = []

    const MinQuestionSet = []
    const MaxQuestionSet = []

    //    let maxRows = 0
    //    let minRows = 0


    //    if (orgRules) {
    if (min_followup > 0 && max_followup > 0) {

//        const getMax = orgRules?.filter(ru => ru?.type === "max")?.[0]?.rows > 0
//        maxRows = orgRules?.filter(ru => ru?.type === "max")?.[0]?.rows
//        const getMin = orgRules?.filter(ru => ru?.type === "min")?.[0]?.rows > 0
//        minRows = orgRules?.filter(ru => ru?.type === "min")?.[0]?.rows


        if (questionAnswers?.questions) {
            const _revisedValues = Object.values(questionAnswers?.questions).map(val => {
                if (val?.reverse === true) {
                    return (
                        {
                            ...val,
                            response: REVERSE[val.response]
                        }
                    )
                }
                return { ...val }
            })

            if (max_followup > 0) {
                const maxValues = _revisedValues.sort((a, b) => b.response - a.response);

                maxValues.map(m => {
                    const _ques = questions[m.ques_order - 1]
                    // filter based on factor and dimensions
                    const _found = MaxQuestionSet.filter(mm => mm?.dimension === _ques?.dimension && mm?.factor === _ques?.factor)?.[0]

                    if (!_found) {
                        MaxQuestionSet.push({
                            dimension: _ques?.dimension,
                            factor: _ques?.factor
                        })

                        MaxQuestions.push({
                            ...m,
                            fr: _ques?.fr,
                            question: _ques?.question,
                            feedback: "",
                            dimension: _ques?.dimension,
                            factor: _ques?.factor,
                            type: 'max'
                        })
                    }

                    return null
                })

            }

            if (min_followup) {
                const minValues = _revisedValues.sort((a, b) => a.response - b.response);

                minValues.map(m => {
                    const _ques = questions[m.ques_order - 1]

                    // filter based on factor and dimensions
                    const _found = MinQuestionSet.filter(mm => mm?.dimension === _ques?.dimension && mm?.factor === _ques?.factor)?.[0]

                    if (!_found) {

                        MinQuestionSet.push({
                            dimension: _ques?.dimension,
                            factor: _ques?.factor
                        })

                        MinQuestions.push({
                            ...m,
                            fr: _ques?.fr,
                            question: _ques?.question,
                            feedback: "",
                            dimension: _ques?.dimension,
                            factor: _ques?.factor,
                            type: 'min'
                        })
                    }

                    return null
                })
            }
        }
    }

    return (
        [
            ...MinQuestions.slice(0, min_followup),
            ...MaxQuestions.slice(0, max_followup)
        ]
    )
}


export default RunRules;